var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex justify-start" },
    [
      _c(
        "v-chip",
        {
          staticClass: "soli-grey px-1",
          class: _vm.certMap[_vm.teacher.certification_level],
          attrs: { "x-small": "" },
        },
        [
          _c(
            "div",
            { class: ["align-center flex"] },
            [
              _c(
                "v-icon",
                { staticClass: "soli-grey", attrs: { "x-small": "" } },
                [_vm._v("star")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "font-bold",
                  staticStyle: { "font-size": "11px", "line-height": "11px" },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        `Musicologie Certified: Level ${_vm.teacher.certification_level}`
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }